import { forwardRef } from 'react';
import MuiChip from '@mui/material/Chip';
import type { ChipProps as MuiChipProps } from '@mui/material/Chip';

/** Alias direto do MUI: nenhum default de aparência do projeto diverge do componente. */
export type ChipProps = MuiChipProps;

/** Chip do design system: mesmo tipo/ref/estrutura de pasta dos demais átomos sem default a fixar — o padrão "pílula azul" de situação é composição, ver a story `Diretrizes`. */
export const Chip = forwardRef<HTMLDivElement, ChipProps>(function Chip(props, ref) {
  return <MuiChip ref={ref} {...props} />;
});
